export const LavendarChevronIcon = ({ width = 8, height = 13 }: { width?: number, height?: number }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.37505 12.9992L0.300049 11.9242L5.25005 6.97422L0.300049 2.02422L1.37505 0.949219L7.40005 6.97422L1.37505 12.9992Z" fill="#807CD6" />
        </svg>
    )
};
